<template>
<div>


<div v-for="(data, index) in foundData.displayIds" @click="select($event, data)"   v-bind ='[{id:data.id}]' :class="{'page_list_row-selected': data.add_info.selected}"  class="page_list_row clearfloat selectable"    >



<div class="gpage_photo">
<img v-bind ='{src:data.photo_100}'/>
</div>
<div class="gpage_info selectable">
<div class="glabeled_name"  >

<v-tooltip v-if="data.add_info.blackList" top open-delay="500" max-width="200">
<v-icon slot="activator" style="margin-right:3px" medium color="red">mdi-alert-circle</v-icon>
<div>
<span>{{data.add_info.blackList.reason_text}}</span>
</div>
</v-tooltip>

<a v-bind ='{href:data.url}' target="_blank"  style="text-decoration:none; color:#42648b;">  <span >{{data.name.substring( 20,-1).toLowerCase()}}</span> <v-tooltip bottom  v-if="data.name.length >28"  max-width="320"> <span slot="activator">...</span><span>{{data.name}}</span></v-tooltip> </a>

</div>
<div class="glabeled selectable"   > </div>
<div style="color:#FF8F18" v-if="data.can_see_members == 0"   class="glabeled selectable" > Закрытые подписчики: <span  >{{data.members_count}}</span> </div>
<div v-else class="glabeled selectable" > Подписчики: {{data.members_count}}  </div>
</div>
<div class="gfunctions">

<v-tooltip v-if="data.can_see_members || data.can_see_members == null " top   open-delay="500" max-width="200" >
<v-btn v-if="!data.add_info.blackList" style="text-transform:none"  slot="activator" block    :loading="data.add_info.adding"  :disabled="data.add_info.added" color="#273C51" small class="white--text"  @click="addGroups(data.id, data)"><v-icon left>mdi-plus</v-icon>Добавить</v-btn>
<div>
<span v-if="!data.add_info.added">После того как группа будет добавлена Вы сможете остлеживать новых подписчиков в разделе АКТИВНОСТЬ</span>
<span v-else>Сообщество уже добавлено в раздел АКТИВНОСТЬ</span>
</div>
</v-tooltip>

<v-tooltip v-if="data.add_info.added" top open-delay="500" max-width="200">
<v-btn @click="deleteConfirm(data)" slot="activator" block small flat color="red" style="text-transform:none">Удалить</v-btn>
<span>Удалить сообщество из раздела АКТИВНОСТЬ</span>
</v-tooltip>

<v-tooltip v-if="data.add_info.blackList" top open-delay="500" max-width="200">
<v-btn @click="delFromBlackList(data)" slot="activator" block small flat color="#4A76A8" style="text-transform:none">Убрать из чс</v-btn>
<span>После того как вы уберете данное сообщество из черного списка, вы сможете его добавить в раздел АКТИВНОСТЬ</span>
</v-tooltip>

 </div>

  </div>

  <v-btn   v-if="loadMore" :loading="this.loadingMore"  block flat  color="#4A76A8"  @click="offSetChanger(foundData,'groups')"
  >
    показать еще {{loadMore}}
   </v-btn>



<v-dialog persistent v-model="modals.deleteGroup" width="500">

   <v-card>
   <v-toolbar dark  color="red" flat  height="42">
   <v-toolbar-title  >  Удаление  из списка активности   </v-toolbar-title>
   <v-spacer></v-spacer>
   <v-icon @click="modals.deleteGroup = false">mdi-close</v-icon>
   </v-toolbar>

   <v-card-text scrollable>

   <div style=" min-height:60px;">
   <div style="float:left; min-width:60px;max-height:55px; overflow:hidden ">  <img :src="toDelete.photo_50" style="border-radius:50%; " > </div>
   <div>  <a style="text-decoration:none" target="_blank"   :href="'https:vk.com/club'+toDelete.id"  >  <span style="color:#4A76A8"> {{toDelete.name}} </span></a></div>
   <span <span style="color:red"> <v-icon small color="red">mdi-alert</v-icon>  Отменить данную операцию будет невозможно.</span>
   </div>

   <v-checkbox v-model="deleteParams.deleteSavedFollowers"  hide-details  color="#232F3A"  >
   <span style="color:#232F3A;margin-top:6px" slot="label">Удалить запомненные подписки</span>
   </v-checkbox>

   <v-checkbox v-model="deleteParams.toBlackList.is" hide-details  color="#232F3A"  >
   <span style="color:#232F3A;margin-top:6px" slot="label">Добавить в черный список</span>
   </v-checkbox>

   <v-text-field v-if="deleteParams.toBlackList.is" v-model="deleteParams.toBlackList.reasonText" solo placeholder="Опишите причину почему в ЧС"></v-text-field>

   </v-card-text>
   <v-divider></v-divider>

   <v-card-actions>
   <v-spacer></v-spacer>
   <v-btn style="text-transform:none" color="#4A76A8" small flat @click="modals.deleteGroup = false">
   Отмена
   </v-btn>
   <v-btn style="text-transform:none" color="red" small class="white--text" @click="deleteConfirmGo()">
   Удалить
   </v-btn>
   </v-card-actions>
   </v-card>
</v-dialog>

  </div>
</template>




<script>
import axios from 'axios'
export default {
props: ['foundData'],
data: function(){
return {
loadingMore:false,
adding: false,

modals:{
deleteGroup:false,
},

toDelete:{},

deleteParams:{
deleteSavedFollowers:false,
toBlackList:{
is:false,
reasonText:"",
}
},

}
},
computed:{
  selectability: function(){
    return this.foundData.selectAll
  },
  loadMore(){

    if(this.foundData.displayIds.length < 20){
      this.offSetChanger(this.foundData,'groups')
      return this.foundData.foundIds.length - this.foundData.displayIds.length
    } else return this.foundData.foundIds.length - this.foundData.displayIds.length
  },
},


methods: {
deleteConfirm(data){
this.toDelete = data
this.modals.deleteGroup = true
},
deleteConfirmGo(){
// Удаление 1 сообщества из списка активность
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_delete.php', {
method: 'POST', data: {ids:this.toDelete.id,params:this.deleteParams}
}).then(response => {
if(this.deleteParams.toBlackList.is){
this.toDelete.add_info.blackList = {}
this.toDelete.add_info.blackList.reason_text = this.deleteParams.toBlackList.reasonText
}
this.toDelete.add_info.added = false
this.$store.dispatch('changeCounters')
this.modals.deleteGroup = false
})
},

offSetChanger (data,type) {
    this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
    let pagesString =  data.foundIds.slice(data.offset, data.offset+20)
    data.offset = data.offset+pagesString.length
  if(pagesString.join(',') !== ''){
    this.loadingMore = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
         method: 'POST',
         data: {
           dataType: type,
           dataString:  pagesString.join(','),
           addInfo:{selected:data.selector}
         }
       })
       .then( response => {
        data.displayIds =   data.displayIds.concat(response.data)
        this.loadingMore = false
       })
     }
  },

delFromBlackList(data){
let groups = []
groups.push(data)
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/delete_from_black_list.php', {
method: 'POST', data: {groups: groups}
}).then(response => {
data.add_info.blackList =  false
})
},

addGroups:function(add_list, data){
data.add_info.adding =  true
this.adding = true

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_add.php', {
method: 'POST', data: {list: add_list}
}).then(response => {
data.add_info.adding =  false
this.adding = false
if(response.data[0].is_added){data.add_info.added =  true} else {
data.can_see_members = 0
}
})
},


  select: function(event,data){
    let id = this.foundData.selectedIds.indexOf(data.id)
    let classes = event.target.className.split(' ')
     if(classes.indexOf('selectable') !== -1){
       data.add_info.selected = !data.add_info.selected
        if(data.add_info.selected  ){

          this.foundData.selectedIds.push(data.id)



        } else this.foundData.selectedIds.splice(id,1)


     //    event.target.className = 'page_list_row-selected'
   }


 },

}
}
</script>

<style>
.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row_selected{
background-color : #EDF0F5;
border-radius : 7px
}



.page_list_row {

  margin: 15px;


  }

.page_list_row:hover {
  margin: 15px;
  border-radius:5px;
  cursor: pointer;
  }

.page_list_row .gpage_info  {

 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 250px;
 height: 80px;
}

.page_list_row .gpage_info .glabeled_name{


    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
.page_list_row .gpage_info .glabeled_name:first-letter{
   text-transform: capitalize;
}




.page_list_row .glabeled {

   color: #656565;
}


.page_list_row .gfunctions {
   padding: 7px 0 0;
 position: relative;
   overflow: hidden;
   width: 150px;
   height: 80px;
 }




.page_list_row .gpage_photo {


   float: left;
   margin: 3px;
   margin-right: 9px;
   position: relative;
   width: 80px;
   height: 80px;
   overflow: hidden;
}

.page_list_row .gpage_photo img {


   width: 80px;
   height: 80px;
   border-radius: 50%;
   -moz-force-broken-image-icon: 0;
   background-color: #fafbfc;
}


</style>
